import PropTypes from 'prop-types';

// ==============================|| PRESET THEME - DEFAULT ||============================== //

const Default = () => {
  const greyColors = {
    0: '#ffffff',
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#f0f0f0',
    300: '#d9d9d9',
    400: '#bfbfbf',
    500: '#8c8c8c',
    600: '#595959',
    700: '#262626',
    800: '#141414',
    900: '#000000',
    A50: '#fafafb',
    A100: '#fafafa',
    A200: '#bfbfbf',
    A400: '#434343',
    A700: '#1f1f1f',
    A800: '#e6ebf1'
  };
  const contrastText = '#fff';

  return {
    primary: {
      lighter: '#e3f2fd',
      100: '#bbdefb',
      200: '#90caf9',
      light: '#64b5f6',
      400: '#42a5f5',
      main: '#2DCDCE',
      dark: '#1976d2',
      700: '#1565c0',
      darker: '#0d47a1',
      900: '#0a3a7a',
      contrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500],
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: greyColors[0]
    },
    error: {
      lighter: '#ffebee',
      light: '#ef9a9a',
      main: '#f44336',
      dark: '#c62828',
      darker: '#b71c1c',
      contrastText
    },
    warning: {
      lighter: '#fff8e1',
      light: '#ffecb3',
      main: '#ffc107',
      dark: '#f57c00',
      darker: '#e65100',
      contrastText: greyColors[100]
    },
    info: {
      lighter: '#e0f7fa',
      light: '#4dd0e1',
      main: '#00bcd4',
      dark: '#0097a7',
      darker: '#006064',
      contrastText
    },
    success: {
      lighter: '#e8f5e9',
      light: '#81c784',
      main: '#4caf50',
      dark: '#388e3c',
      darker: '#1b5e20',
      contrastText
    },
    grey: greyColors
  };
};

Default.propTypes = {
  colors: PropTypes.object
};

export default Default;
